import { render, staticRenderFns } from "./OverviewItem.vue?vue&type=template&id=51cc71b2&scoped=true&"
import script from "./OverviewItem.vue?vue&type=script&lang=js&"
export * from "./OverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./OverviewItem.vue?vue&type=style&index=0&id=51cc71b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc71b2",
  null
  
)

export default component.exports